import React from "react";

import LPHeader from "@/react-components/LPHeader";
import LPFooter from "@/react-components/LPFooter";

class LPMain extends React.Component {
  render() {
    const { className, children, isShowRedBar } = this.props;

    return (
      <div className={`lp-main-container ${className || ""}`}>
        <LPHeader isShowRedBar={isShowRedBar} />
        <div className="lp-main-container-content">{children}</div>
        <LPFooter />
      </div>
    );
  }
}

export default LPMain;
